/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeGCSEquipments.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   GCS Equipment Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, April 01, 2019 - 08:21:08 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      04/01/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const GCSEQUIPMENT_LIST_CONTAINER_LOADED = 'GCSEQUIPMENT_LIST_CONTAINER_LOADED';
export const GCSEQUIPMENT_LIST_CONTAINER_UNLOADED = 'GCSEQUIPMENT_LIST_CONTAINER_UNLOADED';
export const GCSEQUIPMENT_LIST_TABLE_LOADED = 'GCSEQUIPMENT_LIST_TABLE_LOADED';
export const GCSEQUIPMENT_LIST_TABLE_UNLOADED = 'GCSEQUIPMENT_LIST_TABLE_UNLOADED';

export const GCSEQUIPMENT_LIST_CHANGE_GROUP = 'GCSEQUIPMENT_LIST_CHANGE_GROUP';
export const GCSEQUIPMENT_SELECT_ROW = 'GCSEQUIPMENT_SELECT_ROW';

export const GCSEQUIPMENT_ADD = 'GCSEQUIPMENT_ADD';
export const GCSEQUIPMENT_EDIT = 'GCSEQUIPMENT_EDIT';
export const GCSEQUIPMENT_DELETE = 'GCSEQUIPMENT_DELETE';
export const GCSEQUIPMENT_OPEN_WARNING = 'GCSEQUIPMENT_OPEN_WARNING';
export const GCSEQUIPMENT_CLOSE_WARNING = 'GCSEQUIPMENT_CLOSE_WARNING';
export const GCSEQUIPMENT_DELETE_DISABLE = 'GCSEQUIPMENT_DELETE_DISABLE';
export const GCSEQUIPMENT_VIEW_CHILD_ITEMS = 'GCSEQUIPMENT_VIEW_CHILD_ITEMS';

export const GCSEQUIPMENT_EDIT_CONTAINER_LOADED = 'GCSEQUIPMENT_EDIT_CONTAINER_LOADED';
export const GCSEQUIPMENT_EDIT_CONTAINER_UNLOADED = 'GCSEQUIPMENT_EDIT_CONTAINER_UNLOADED';
export const GCSEQUIPMENT_EDIT_FORM_LOADED = 'GCSEQUIPMENT_EDIT_FORM_LOADED';
export const GCSEQUIPMENT_EDIT_FORM_UNLOADED = 'GCSEQUIPMENT_EDIT_FORM_UNLOADED';

export const GCSEQUIPMENT_SET_GROUP_SELECT = 'GCSEQUIPMENT_SET_GROUP_SELECT';
export const GCSEQUIPMENT_EDIT_DATA_LOAD = 'GCSEQUIPMENT_EDIT_DATA_LOAD';

export const GCSEQUIPMENT_EDIT_CONTAINER_SUBMIT = 'GCSEQUIPMENT_EDIT_CONTAINER_SUBMIT';
export const GCSEQUIPMENT_EDIT_CONTAINER_CANCEL = 'GCSEQUIPMENT_EDIT_CONTAINER_CANCEL';

export const GCSEQUIPMENT_SET_VALUE = 'GCSEQUIPMENT_SET_VALUE';


// WEBPACK FOOTER //
// ./src/constants/actionTypeGCSEquipments.js